/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const PageDocument = gql`
    query Page($id: Int!) {
  page(id: $id) {
    user {
      id
      email
    }
    id
    title
    image
    publicUrl
    type
    computedUrl
    purposeType
    pageWatermark
    project {
      id
      title
    }
    subPages {
      id
      title
    }
    page {
      id
      title
      seoTitle
      seoKeywords
      seoDescription
      publicUrl
      pageUrl
      publishedAt
      noIndex
      script
    }
    domain {
      id
      title
      userAccesses {
        id
        accessType
        email
        user {
          id
          email
        }
      }
    }
    folder {
      id
      title
    }
    userAccesses {
      id
      accessType
      email
      user {
        id
        email
      }
    }
    pagePageCategory {
      id
      position
      positionMeQr
      pageCategory {
        id
        title
      }
    }
    accessPageFolderDomainByPriority
    pageLocationRestrictions {
      id
      isExactCheck
      isExactRequired
      hint
      pageLocationRestrictionItems {
        id
        city {
          id
          title
        }
        country {
          id
          title
        }
        latitude
        longitude
        radius
        rule
      }
    }
    pageScheduleAssess {
      id
      link
      dateStart
      dateEnd
      scheduleAccess
      showNothing
      fileName
      filePath
      pageSchedules {
        id
        day
        dateStart
        dateEnd
        isActive
      }
      timezone {
        id
        name
      }
    }
    pageRestriction {
      id
      password
      passwordHint
      checkboxPassword
    }
  }
}
    `;

/**
 * __usePageQuery__
 *
 * To run a query within a React component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePageQuery(baseOptions: Apollo.QueryHookOptions<PageQuery, PageQueryVariables> & ({ variables: PageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageQuery, PageQueryVariables>(PageDocument, options);
      }
export function usePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageQuery, PageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageQuery, PageQueryVariables>(PageDocument, options);
        }
// @ts-ignore
export function usePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageQuery, PageQueryVariables>): Apollo.UseSuspenseQueryResult<PageQuery, PageQueryVariables>;
export function usePageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageQuery, PageQueryVariables>): Apollo.UseSuspenseQueryResult<PageQuery | undefined, PageQueryVariables>;
export function usePageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageQuery, PageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageQuery, PageQueryVariables>(PageDocument, options);
        }
export type PageQueryHookResult = ReturnType<typeof usePageQuery>;
export type PageLazyQueryHookResult = ReturnType<typeof usePageLazyQuery>;
export type PageSuspenseQueryHookResult = ReturnType<typeof usePageSuspenseQuery>;
export type PageQueryResult = Apollo.QueryResult<PageQuery, PageQueryVariables>;
export const UpdatePageDocument = gql`
    mutation UpdatePage($id: Int, $title: String, $seoTitle: String, $seoKeyWords: String, $seoDescription: String, $image: String, $folderId: Int, $domainId: Int, $url: String, $pageCategoryIds: [GraphPagePageCategoryInput!], $noIndex: Boolean, $pageScript: String, $watermark: Boolean) {
  updatePage(
    id: $id
    title: $title
    seoTitle: $seoTitle
    seoKeyWords: $seoKeyWords
    seoDescription: $seoDescription
    image: $image
    folderId: $folderId
    domainId: $domainId
    url: $url
    pageCategoryIds: $pageCategoryIds
    noIndex: $noIndex
    pageScript: $pageScript
    watermark: $watermark
  ) {
    id
  }
}
    `;
export type UpdatePageMutationFn = Apollo.MutationFunction<UpdatePageMutation, UpdatePageMutationVariables>;

/**
 * __useUpdatePageMutation__
 *
 * To run a mutation, you first call `useUpdatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageMutation, { data, loading, error }] = useUpdatePageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      seoTitle: // value for 'seoTitle'
 *      seoKeyWords: // value for 'seoKeyWords'
 *      seoDescription: // value for 'seoDescription'
 *      image: // value for 'image'
 *      folderId: // value for 'folderId'
 *      domainId: // value for 'domainId'
 *      url: // value for 'url'
 *      pageCategoryIds: // value for 'pageCategoryIds'
 *      noIndex: // value for 'noIndex'
 *      pageScript: // value for 'pageScript'
 *      watermark: // value for 'watermark'
 *   },
 * });
 */
export function useUpdatePageMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageMutation, UpdatePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageMutation, UpdatePageMutationVariables>(UpdatePageDocument, options);
      }
export type UpdatePageMutationHookResult = ReturnType<typeof useUpdatePageMutation>;
export type UpdatePageMutationResult = Apollo.MutationResult<UpdatePageMutation>;
export type UpdatePageMutationOptions = Apollo.BaseMutationOptions<UpdatePageMutation, UpdatePageMutationVariables>;
export const PageNewDocument = gql`
    mutation PageNew($title: String!, $seoTitle: String, $seoKeyWords: String, $seoDescription: String, $folderId: Int, $domainId: Int, $url: String!, $type: Int, $noIndex: Boolean) {
  pageNew(
    title: $title
    seoTitle: $seoTitle
    seoKeyWords: $seoKeyWords
    seoDescription: $seoDescription
    folderId: $folderId
    domainId: $domainId
    url: $url
    type: $type
    noIndex: $noIndex
  ) {
    id
    domain {
      id
    }
    folder {
      id
    }
  }
}
    `;
export type PageNewMutationFn = Apollo.MutationFunction<PageNewMutation, PageNewMutationVariables>;

/**
 * __usePageNewMutation__
 *
 * To run a mutation, you first call `usePageNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePageNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pageNewMutation, { data, loading, error }] = usePageNewMutation({
 *   variables: {
 *      title: // value for 'title'
 *      seoTitle: // value for 'seoTitle'
 *      seoKeyWords: // value for 'seoKeyWords'
 *      seoDescription: // value for 'seoDescription'
 *      folderId: // value for 'folderId'
 *      domainId: // value for 'domainId'
 *      url: // value for 'url'
 *      type: // value for 'type'
 *      noIndex: // value for 'noIndex'
 *   },
 * });
 */
export function usePageNewMutation(baseOptions?: Apollo.MutationHookOptions<PageNewMutation, PageNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PageNewMutation, PageNewMutationVariables>(PageNewDocument, options);
      }
export type PageNewMutationHookResult = ReturnType<typeof usePageNewMutation>;
export type PageNewMutationResult = Apollo.MutationResult<PageNewMutation>;
export type PageNewMutationOptions = Apollo.BaseMutationOptions<PageNewMutation, PageNewMutationVariables>;
export const DuplicatePageDocument = gql`
    mutation DuplicatePage($id: Int, $isPublish: Boolean, $duplicateFile: Boolean, $folderId: Int, $domainId: Int, $title: String, $url: String, $seoTitle: String, $seoDescription: String, $seoKeyWords: String, $type: Int) {
  duplicatePage(
    id: $id
    isPublish: $isPublish
    duplicateFile: $duplicateFile
    folderId: $folderId
    domainId: $domainId
    title: $title
    url: $url
    seoTitle: $seoTitle
    seoDescription: $seoDescription
    seoKeyWords: $seoKeyWords
    type: $type
  ) {
    id
  }
}
    `;
export type DuplicatePageMutationFn = Apollo.MutationFunction<DuplicatePageMutation, DuplicatePageMutationVariables>;

/**
 * __useDuplicatePageMutation__
 *
 * To run a mutation, you first call `useDuplicatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicatePageMutation, { data, loading, error }] = useDuplicatePageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isPublish: // value for 'isPublish'
 *      duplicateFile: // value for 'duplicateFile'
 *      folderId: // value for 'folderId'
 *      domainId: // value for 'domainId'
 *      title: // value for 'title'
 *      url: // value for 'url'
 *      seoTitle: // value for 'seoTitle'
 *      seoDescription: // value for 'seoDescription'
 *      seoKeyWords: // value for 'seoKeyWords'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useDuplicatePageMutation(baseOptions?: Apollo.MutationHookOptions<DuplicatePageMutation, DuplicatePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicatePageMutation, DuplicatePageMutationVariables>(DuplicatePageDocument, options);
      }
export type DuplicatePageMutationHookResult = ReturnType<typeof useDuplicatePageMutation>;
export type DuplicatePageMutationResult = Apollo.MutationResult<DuplicatePageMutation>;
export type DuplicatePageMutationOptions = Apollo.BaseMutationOptions<DuplicatePageMutation, DuplicatePageMutationVariables>;
export const DuplicatePageForCommonPageDocument = gql`
    mutation DuplicatePageForCommonPage($id: Int, $isPublish: Boolean, $duplicateFile: Boolean, $folderId: Int, $domainId: Int, $title: String, $url: String, $seoTitle: String, $seoDescription: String, $seoKeyWords: String, $type: Int, $noIndex: Boolean) {
  duplicatePageForCommonPage(
    id: $id
    isPublish: $isPublish
    duplicateFile: $duplicateFile
    folderId: $folderId
    domainId: $domainId
    title: $title
    url: $url
    seoTitle: $seoTitle
    seoDescription: $seoDescription
    seoKeyWords: $seoKeyWords
    type: $type
    noIndex: $noIndex
  ) {
    id
    type
    publicUrl
    pageUrl
    page {
      id
    }
  }
}
    `;
export type DuplicatePageForCommonPageMutationFn = Apollo.MutationFunction<DuplicatePageForCommonPageMutation, DuplicatePageForCommonPageMutationVariables>;

/**
 * __useDuplicatePageForCommonPageMutation__
 *
 * To run a mutation, you first call `useDuplicatePageForCommonPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicatePageForCommonPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicatePageForCommonPageMutation, { data, loading, error }] = useDuplicatePageForCommonPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isPublish: // value for 'isPublish'
 *      duplicateFile: // value for 'duplicateFile'
 *      folderId: // value for 'folderId'
 *      domainId: // value for 'domainId'
 *      title: // value for 'title'
 *      url: // value for 'url'
 *      seoTitle: // value for 'seoTitle'
 *      seoDescription: // value for 'seoDescription'
 *      seoKeyWords: // value for 'seoKeyWords'
 *      type: // value for 'type'
 *      noIndex: // value for 'noIndex'
 *   },
 * });
 */
export function useDuplicatePageForCommonPageMutation(baseOptions?: Apollo.MutationHookOptions<DuplicatePageForCommonPageMutation, DuplicatePageForCommonPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicatePageForCommonPageMutation, DuplicatePageForCommonPageMutationVariables>(DuplicatePageForCommonPageDocument, options);
      }
export type DuplicatePageForCommonPageMutationHookResult = ReturnType<typeof useDuplicatePageForCommonPageMutation>;
export type DuplicatePageForCommonPageMutationResult = Apollo.MutationResult<DuplicatePageForCommonPageMutation>;
export type DuplicatePageForCommonPageMutationOptions = Apollo.BaseMutationOptions<DuplicatePageForCommonPageMutation, DuplicatePageForCommonPageMutationVariables>;
export const DuplicateContentPageForCommonPageDocument = gql`
    mutation DuplicateContentPageForCommonPage($idPageFrom: Int!, $idPageTo: Int!) {
  duplicateContentPageForCommonPage(idPageFrom: $idPageFrom, idPageTo: $idPageTo) {
    id
    type
    title
  }
}
    `;
export type DuplicateContentPageForCommonPageMutationFn = Apollo.MutationFunction<DuplicateContentPageForCommonPageMutation, DuplicateContentPageForCommonPageMutationVariables>;

/**
 * __useDuplicateContentPageForCommonPageMutation__
 *
 * To run a mutation, you first call `useDuplicateContentPageForCommonPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateContentPageForCommonPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateContentPageForCommonPageMutation, { data, loading, error }] = useDuplicateContentPageForCommonPageMutation({
 *   variables: {
 *      idPageFrom: // value for 'idPageFrom'
 *      idPageTo: // value for 'idPageTo'
 *   },
 * });
 */
export function useDuplicateContentPageForCommonPageMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateContentPageForCommonPageMutation, DuplicateContentPageForCommonPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateContentPageForCommonPageMutation, DuplicateContentPageForCommonPageMutationVariables>(DuplicateContentPageForCommonPageDocument, options);
      }
export type DuplicateContentPageForCommonPageMutationHookResult = ReturnType<typeof useDuplicateContentPageForCommonPageMutation>;
export type DuplicateContentPageForCommonPageMutationResult = Apollo.MutationResult<DuplicateContentPageForCommonPageMutation>;
export type DuplicateContentPageForCommonPageMutationOptions = Apollo.BaseMutationOptions<DuplicateContentPageForCommonPageMutation, DuplicateContentPageForCommonPageMutationVariables>;
export const MoveFolderAjaxDocument = gql`
    mutation MoveFolderAjax($pageId: Int!, $folderId: Int, $domainId: Int) {
  moveFolderAjax(pageId: $pageId, folderId: $folderId, domainId: $domainId) {
    redirectPath
    statusCode
    params
  }
}
    `;
export type MoveFolderAjaxMutationFn = Apollo.MutationFunction<MoveFolderAjaxMutation, MoveFolderAjaxMutationVariables>;

/**
 * __useMoveFolderAjaxMutation__
 *
 * To run a mutation, you first call `useMoveFolderAjaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveFolderAjaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveFolderAjaxMutation, { data, loading, error }] = useMoveFolderAjaxMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      folderId: // value for 'folderId'
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useMoveFolderAjaxMutation(baseOptions?: Apollo.MutationHookOptions<MoveFolderAjaxMutation, MoveFolderAjaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveFolderAjaxMutation, MoveFolderAjaxMutationVariables>(MoveFolderAjaxDocument, options);
      }
export type MoveFolderAjaxMutationHookResult = ReturnType<typeof useMoveFolderAjaxMutation>;
export type MoveFolderAjaxMutationResult = Apollo.MutationResult<MoveFolderAjaxMutation>;
export type MoveFolderAjaxMutationOptions = Apollo.BaseMutationOptions<MoveFolderAjaxMutation, MoveFolderAjaxMutationVariables>;
export const PublishPageFromAdminPanelDocument = gql`
    mutation PublishPageFromAdminPanel($pageId: Int!) {
  publishPageFromAdminPanel(pageId: $pageId) {
    id
  }
}
    `;
export type PublishPageFromAdminPanelMutationFn = Apollo.MutationFunction<PublishPageFromAdminPanelMutation, PublishPageFromAdminPanelMutationVariables>;

/**
 * __usePublishPageFromAdminPanelMutation__
 *
 * To run a mutation, you first call `usePublishPageFromAdminPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishPageFromAdminPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishPageFromAdminPanelMutation, { data, loading, error }] = usePublishPageFromAdminPanelMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function usePublishPageFromAdminPanelMutation(baseOptions?: Apollo.MutationHookOptions<PublishPageFromAdminPanelMutation, PublishPageFromAdminPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishPageFromAdminPanelMutation, PublishPageFromAdminPanelMutationVariables>(PublishPageFromAdminPanelDocument, options);
      }
export type PublishPageFromAdminPanelMutationHookResult = ReturnType<typeof usePublishPageFromAdminPanelMutation>;
export type PublishPageFromAdminPanelMutationResult = Apollo.MutationResult<PublishPageFromAdminPanelMutation>;
export type PublishPageFromAdminPanelMutationOptions = Apollo.BaseMutationOptions<PublishPageFromAdminPanelMutation, PublishPageFromAdminPanelMutationVariables>;
export const PagesDocument = gql`
    query Pages($search: String, $page: Int, $limit: Int) {
  pages(search: $search, page: $page, limit: $limit) {
    search
    pages {
      id
      type
      title
      image
      user {
        email
      }
      publicUrl
      publishedAt
    }
    paginator {
      totalPages
      currentPageNumber
      itemNumberPerPage
      totalItemCount
    }
    itFolder
    pageView
  }
}
    `;

/**
 * __usePagesQuery__
 *
 * To run a query within a React component, call `usePagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePagesQuery(baseOptions?: Apollo.QueryHookOptions<PagesQuery, PagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagesQuery, PagesQueryVariables>(PagesDocument, options);
      }
export function usePagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagesQuery, PagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagesQuery, PagesQueryVariables>(PagesDocument, options);
        }
// @ts-ignore
export function usePagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PagesQuery, PagesQueryVariables>): Apollo.UseSuspenseQueryResult<PagesQuery, PagesQueryVariables>;
export function usePagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagesQuery, PagesQueryVariables>): Apollo.UseSuspenseQueryResult<PagesQuery | undefined, PagesQueryVariables>;
export function usePagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagesQuery, PagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagesQuery, PagesQueryVariables>(PagesDocument, options);
        }
export type PagesQueryHookResult = ReturnType<typeof usePagesQuery>;
export type PagesLazyQueryHookResult = ReturnType<typeof usePagesLazyQuery>;
export type PagesSuspenseQueryHookResult = ReturnType<typeof usePagesSuspenseQuery>;
export type PagesQueryResult = Apollo.QueryResult<PagesQuery, PagesQueryVariables>;
export const MassMoveFolderAndPageDocument = gql`
    mutation MassMoveFolderAndPage($pageIds: [Int!], $folderIds: [Int!], $toFolderId: Int, $domainId: Int) {
  massMoveFolderAndPage(
    pageIds: $pageIds
    folderIds: $folderIds
    toFolderId: $toFolderId
    domainId: $domainId
  ) {
    redirectPath
    statusCode
    params
  }
}
    `;
export type MassMoveFolderAndPageMutationFn = Apollo.MutationFunction<MassMoveFolderAndPageMutation, MassMoveFolderAndPageMutationVariables>;

/**
 * __useMassMoveFolderAndPageMutation__
 *
 * To run a mutation, you first call `useMassMoveFolderAndPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMassMoveFolderAndPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [massMoveFolderAndPageMutation, { data, loading, error }] = useMassMoveFolderAndPageMutation({
 *   variables: {
 *      pageIds: // value for 'pageIds'
 *      folderIds: // value for 'folderIds'
 *      toFolderId: // value for 'toFolderId'
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useMassMoveFolderAndPageMutation(baseOptions?: Apollo.MutationHookOptions<MassMoveFolderAndPageMutation, MassMoveFolderAndPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MassMoveFolderAndPageMutation, MassMoveFolderAndPageMutationVariables>(MassMoveFolderAndPageDocument, options);
      }
export type MassMoveFolderAndPageMutationHookResult = ReturnType<typeof useMassMoveFolderAndPageMutation>;
export type MassMoveFolderAndPageMutationResult = Apollo.MutationResult<MassMoveFolderAndPageMutation>;
export type MassMoveFolderAndPageMutationOptions = Apollo.BaseMutationOptions<MassMoveFolderAndPageMutation, MassMoveFolderAndPageMutationVariables>;
export const MassDeleteFolderAndPageDocument = gql`
    mutation MassDeleteFolderAndPage($pageIds: [Int!], $folderIds: [Int!]) {
  massDeleteFolderAndPage(pageIds: $pageIds, folderIds: $folderIds)
}
    `;
export type MassDeleteFolderAndPageMutationFn = Apollo.MutationFunction<MassDeleteFolderAndPageMutation, MassDeleteFolderAndPageMutationVariables>;

/**
 * __useMassDeleteFolderAndPageMutation__
 *
 * To run a mutation, you first call `useMassDeleteFolderAndPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMassDeleteFolderAndPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [massDeleteFolderAndPageMutation, { data, loading, error }] = useMassDeleteFolderAndPageMutation({
 *   variables: {
 *      pageIds: // value for 'pageIds'
 *      folderIds: // value for 'folderIds'
 *   },
 * });
 */
export function useMassDeleteFolderAndPageMutation(baseOptions?: Apollo.MutationHookOptions<MassDeleteFolderAndPageMutation, MassDeleteFolderAndPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MassDeleteFolderAndPageMutation, MassDeleteFolderAndPageMutationVariables>(MassDeleteFolderAndPageDocument, options);
      }
export type MassDeleteFolderAndPageMutationHookResult = ReturnType<typeof useMassDeleteFolderAndPageMutation>;
export type MassDeleteFolderAndPageMutationResult = Apollo.MutationResult<MassDeleteFolderAndPageMutation>;
export type MassDeleteFolderAndPageMutationOptions = Apollo.BaseMutationOptions<MassDeleteFolderAndPageMutation, MassDeleteFolderAndPageMutationVariables>;
export const PagesByAdminDocument = gql`
    query PagesByAdmin($page: Int, $limit: Int, $search: String) {
  pagesByAdmin(search: $search, limit: $limit, page: $page) {
    pages {
      id
      createdAt
      project {
        id
      }
      user {
        email
      }
      block
      userGraphObject {
        id
        userBlock {
          status
        }
      }
    }
    paginator {
      totalPages
      currentPageNumber
      itemNumberPerPage
      totalItemCount
    }
  }
}
    `;

/**
 * __usePagesByAdminQuery__
 *
 * To run a query within a React component, call `usePagesByAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesByAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesByAdminQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function usePagesByAdminQuery(baseOptions?: Apollo.QueryHookOptions<PagesByAdminQuery, PagesByAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagesByAdminQuery, PagesByAdminQueryVariables>(PagesByAdminDocument, options);
      }
export function usePagesByAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagesByAdminQuery, PagesByAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagesByAdminQuery, PagesByAdminQueryVariables>(PagesByAdminDocument, options);
        }
// @ts-ignore
export function usePagesByAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PagesByAdminQuery, PagesByAdminQueryVariables>): Apollo.UseSuspenseQueryResult<PagesByAdminQuery, PagesByAdminQueryVariables>;
export function usePagesByAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagesByAdminQuery, PagesByAdminQueryVariables>): Apollo.UseSuspenseQueryResult<PagesByAdminQuery | undefined, PagesByAdminQueryVariables>;
export function usePagesByAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagesByAdminQuery, PagesByAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagesByAdminQuery, PagesByAdminQueryVariables>(PagesByAdminDocument, options);
        }
export type PagesByAdminQueryHookResult = ReturnType<typeof usePagesByAdminQuery>;
export type PagesByAdminLazyQueryHookResult = ReturnType<typeof usePagesByAdminLazyQuery>;
export type PagesByAdminSuspenseQueryHookResult = ReturnType<typeof usePagesByAdminSuspenseQuery>;
export type PagesByAdminQueryResult = Apollo.QueryResult<PagesByAdminQuery, PagesByAdminQueryVariables>;
export const SetBlockPageDocument = gql`
    mutation SetBlockPage($pageId: Int!, $block: Boolean!) {
  setBlockPage(pageId: $pageId, block: $block) {
    id
  }
}
    `;
export type SetBlockPageMutationFn = Apollo.MutationFunction<SetBlockPageMutation, SetBlockPageMutationVariables>;

/**
 * __useSetBlockPageMutation__
 *
 * To run a mutation, you first call `useSetBlockPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBlockPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBlockPageMutation, { data, loading, error }] = useSetBlockPageMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      block: // value for 'block'
 *   },
 * });
 */
export function useSetBlockPageMutation(baseOptions?: Apollo.MutationHookOptions<SetBlockPageMutation, SetBlockPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetBlockPageMutation, SetBlockPageMutationVariables>(SetBlockPageDocument, options);
      }
export type SetBlockPageMutationHookResult = ReturnType<typeof useSetBlockPageMutation>;
export type SetBlockPageMutationResult = Apollo.MutationResult<SetBlockPageMutation>;
export type SetBlockPageMutationOptions = Apollo.BaseMutationOptions<SetBlockPageMutation, SetBlockPageMutationVariables>;
export const PagesByIdsByAdminDocument = gql`
    query PagesByIdsByAdmin($ids: [Int!]!) {
  pagesByIdsByAdmin(ids: $ids) {
    id
    type
    publishContentString
    prePublishContentString
    folder {
      id
    }
  }
}
    `;

/**
 * __usePagesByIdsByAdminQuery__
 *
 * To run a query within a React component, call `usePagesByIdsByAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesByIdsByAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesByIdsByAdminQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePagesByIdsByAdminQuery(baseOptions: Apollo.QueryHookOptions<PagesByIdsByAdminQuery, PagesByIdsByAdminQueryVariables> & ({ variables: PagesByIdsByAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagesByIdsByAdminQuery, PagesByIdsByAdminQueryVariables>(PagesByIdsByAdminDocument, options);
      }
export function usePagesByIdsByAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagesByIdsByAdminQuery, PagesByIdsByAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagesByIdsByAdminQuery, PagesByIdsByAdminQueryVariables>(PagesByIdsByAdminDocument, options);
        }
// @ts-ignore
export function usePagesByIdsByAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PagesByIdsByAdminQuery, PagesByIdsByAdminQueryVariables>): Apollo.UseSuspenseQueryResult<PagesByIdsByAdminQuery, PagesByIdsByAdminQueryVariables>;
export function usePagesByIdsByAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagesByIdsByAdminQuery, PagesByIdsByAdminQueryVariables>): Apollo.UseSuspenseQueryResult<PagesByIdsByAdminQuery | undefined, PagesByIdsByAdminQueryVariables>;
export function usePagesByIdsByAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagesByIdsByAdminQuery, PagesByIdsByAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagesByIdsByAdminQuery, PagesByIdsByAdminQueryVariables>(PagesByIdsByAdminDocument, options);
        }
export type PagesByIdsByAdminQueryHookResult = ReturnType<typeof usePagesByIdsByAdminQuery>;
export type PagesByIdsByAdminLazyQueryHookResult = ReturnType<typeof usePagesByIdsByAdminLazyQuery>;
export type PagesByIdsByAdminSuspenseQueryHookResult = ReturnType<typeof usePagesByIdsByAdminSuspenseQuery>;
export type PagesByIdsByAdminQueryResult = Apollo.QueryResult<PagesByIdsByAdminQuery, PagesByIdsByAdminQueryVariables>;
export const UpdatePageScreeShotDocument = gql`
    mutation updatePageScreeShot($id: Int, $image: String, $folderId: Int) {
  updatePage(id: $id, image: $image, folderId: $folderId) {
    image
  }
}
    `;
export type UpdatePageScreeShotMutationFn = Apollo.MutationFunction<UpdatePageScreeShotMutation, UpdatePageScreeShotMutationVariables>;

/**
 * __useUpdatePageScreeShotMutation__
 *
 * To run a mutation, you first call `useUpdatePageScreeShotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageScreeShotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageScreeShotMutation, { data, loading, error }] = useUpdatePageScreeShotMutation({
 *   variables: {
 *      id: // value for 'id'
 *      image: // value for 'image'
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useUpdatePageScreeShotMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageScreeShotMutation, UpdatePageScreeShotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageScreeShotMutation, UpdatePageScreeShotMutationVariables>(UpdatePageScreeShotDocument, options);
      }
export type UpdatePageScreeShotMutationHookResult = ReturnType<typeof useUpdatePageScreeShotMutation>;
export type UpdatePageScreeShotMutationResult = Apollo.MutationResult<UpdatePageScreeShotMutation>;
export type UpdatePageScreeShotMutationOptions = Apollo.BaseMutationOptions<UpdatePageScreeShotMutation, UpdatePageScreeShotMutationVariables>;
export const UpdatePageSettingsDocument = gql`
    mutation UpdatePageSettings($isExactRequired: Int, $isExactCheck: Int, $locationHint: String, $checkboxPassword: Int, $password: String, $passwordHint: String, $scheduleAccessObj: PageScheduleAccessInput, $locationObjects: PageLocationRestrictionsInput, $id: [Int!]!) {
  updatePageSettings(
    isExactRequired: $isExactRequired
    isExactCheck: $isExactCheck
    locationHint: $locationHint
    checkboxPassword: $checkboxPassword
    password: $password
    passwordHint: $passwordHint
    scheduleAccessObj: $scheduleAccessObj
    locationObjects: $locationObjects
    id: $id
  ) {
    id
  }
}
    `;
export type UpdatePageSettingsMutationFn = Apollo.MutationFunction<UpdatePageSettingsMutation, UpdatePageSettingsMutationVariables>;

/**
 * __useUpdatePageSettingsMutation__
 *
 * To run a mutation, you first call `useUpdatePageSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageSettingsMutation, { data, loading, error }] = useUpdatePageSettingsMutation({
 *   variables: {
 *      isExactRequired: // value for 'isExactRequired'
 *      isExactCheck: // value for 'isExactCheck'
 *      locationHint: // value for 'locationHint'
 *      checkboxPassword: // value for 'checkboxPassword'
 *      password: // value for 'password'
 *      passwordHint: // value for 'passwordHint'
 *      scheduleAccessObj: // value for 'scheduleAccessObj'
 *      locationObjects: // value for 'locationObjects'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdatePageSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageSettingsMutation, UpdatePageSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageSettingsMutation, UpdatePageSettingsMutationVariables>(UpdatePageSettingsDocument, options);
      }
export type UpdatePageSettingsMutationHookResult = ReturnType<typeof useUpdatePageSettingsMutation>;
export type UpdatePageSettingsMutationResult = Apollo.MutationResult<UpdatePageSettingsMutation>;
export type UpdatePageSettingsMutationOptions = Apollo.BaseMutationOptions<UpdatePageSettingsMutation, UpdatePageSettingsMutationVariables>;
export const CountryByFieldDocument = gql`
    query CountryByField($field: String!, $search: String!, $citiesLimit: Int = 50, $citiesSearch: String, $afterValue: String, $afterId: Int) {
  countryByField(field: $field, search: $search) {
    id
    title
    cities(
      limit: $citiesLimit
      order: "ASC"
      field: "title"
      search: $citiesSearch
      afterValue: $afterValue
      afterId: $afterId
    ) {
      id
      title
    }
  }
}
    `;

/**
 * __useCountryByFieldQuery__
 *
 * To run a query within a React component, call `useCountryByFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountryByFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountryByFieldQuery({
 *   variables: {
 *      field: // value for 'field'
 *      search: // value for 'search'
 *      citiesLimit: // value for 'citiesLimit'
 *      citiesSearch: // value for 'citiesSearch'
 *      afterValue: // value for 'afterValue'
 *      afterId: // value for 'afterId'
 *   },
 * });
 */
export function useCountryByFieldQuery(baseOptions: Apollo.QueryHookOptions<CountryByFieldQuery, CountryByFieldQueryVariables> & ({ variables: CountryByFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountryByFieldQuery, CountryByFieldQueryVariables>(CountryByFieldDocument, options);
      }
export function useCountryByFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountryByFieldQuery, CountryByFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountryByFieldQuery, CountryByFieldQueryVariables>(CountryByFieldDocument, options);
        }
// @ts-ignore
export function useCountryByFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountryByFieldQuery, CountryByFieldQueryVariables>): Apollo.UseSuspenseQueryResult<CountryByFieldQuery, CountryByFieldQueryVariables>;
export function useCountryByFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountryByFieldQuery, CountryByFieldQueryVariables>): Apollo.UseSuspenseQueryResult<CountryByFieldQuery | undefined, CountryByFieldQueryVariables>;
export function useCountryByFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountryByFieldQuery, CountryByFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountryByFieldQuery, CountryByFieldQueryVariables>(CountryByFieldDocument, options);
        }
export type CountryByFieldQueryHookResult = ReturnType<typeof useCountryByFieldQuery>;
export type CountryByFieldLazyQueryHookResult = ReturnType<typeof useCountryByFieldLazyQuery>;
export type CountryByFieldSuspenseQueryHookResult = ReturnType<typeof useCountryByFieldSuspenseQuery>;
export type CountryByFieldQueryResult = Apollo.QueryResult<CountryByFieldQuery, CountryByFieldQueryVariables>;
export type PageQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type PageQuery = { __typename?: 'Query', page: { __typename?: 'GraphPage', id?: number | null, title?: string | null, image?: string | null, publicUrl?: string | null, type?: number | null, computedUrl?: string | null, purposeType?: number | null, pageWatermark?: boolean | null, accessPageFolderDomainByPriority: number, user: { __typename?: 'User', id?: number | null, email?: string | null }, project?: { __typename?: 'GraphDomain', id?: number | null, title?: string | null } | null, subPages: Array<{ __typename?: 'GraphPage', id?: number | null, title?: string | null }>, page?: { __typename?: 'GraphPage', id?: number | null, title?: string | null, seoTitle?: string | null, seoKeywords?: string | null, seoDescription?: string | null, publicUrl?: string | null, pageUrl?: string | null, publishedAt?: any | null, noIndex?: boolean | null, script?: string | null } | null, domain: { __typename?: 'GraphDomain', id?: number | null, title?: string | null, userAccesses: Array<{ __typename?: 'UserAccess', id?: number | null, accessType?: number | null, email?: string | null, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null }> }, folder?: { __typename?: 'GraphFolder', id: number, title: string } | null, userAccesses: Array<{ __typename?: 'UserAccess', id?: number | null, accessType?: number | null, email?: string | null, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null }>, pagePageCategory: Array<{ __typename?: 'GraphPagePageCategory', id?: number | null, position?: number | null, positionMeQr?: number | null, pageCategory: { __typename?: 'GraphPageCategory', id?: number | null, title?: string | null } }>, pageLocationRestrictions?: { __typename?: 'GraphPageLocationRestrictions', id?: number | null, isExactCheck?: boolean | null, isExactRequired?: boolean | null, hint?: string | null, pageLocationRestrictionItems: Array<{ __typename?: 'GraphPageLocationRestrictionItems', id?: number | null, latitude?: number | null, longitude?: number | null, radius?: number | null, rule?: number | null, city?: { __typename?: 'GraphCity', id?: number | null, title: string } | null, country?: { __typename?: 'GraphCountry', id?: number | null, title: string } | null }> } | null, pageScheduleAssess?: { __typename?: 'GraphPageScheduleAssess', id?: number | null, link?: string | null, dateStart?: any | null, dateEnd?: any | null, scheduleAccess: boolean, showNothing?: boolean | null, fileName?: string | null, filePath?: string | null, pageSchedules: Array<{ __typename?: 'GraphPageSchedule', id?: number | null, day?: string | null, dateStart?: any | null, dateEnd?: any | null, isActive: boolean }>, timezone?: { __typename?: 'GraphTimezone', id?: number | null, name: string } | null } | null, pageRestriction?: { __typename?: 'GraphPageRestriction', id?: number | null, password?: string | null, passwordHint?: string | null, checkboxPassword: boolean } | null } };

export type UpdatePageMutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  title?: Types.InputMaybe<Types.Scalars['String']['input']>;
  seoTitle?: Types.InputMaybe<Types.Scalars['String']['input']>;
  seoKeyWords?: Types.InputMaybe<Types.Scalars['String']['input']>;
  seoDescription?: Types.InputMaybe<Types.Scalars['String']['input']>;
  image?: Types.InputMaybe<Types.Scalars['String']['input']>;
  folderId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  domainId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  url?: Types.InputMaybe<Types.Scalars['String']['input']>;
  pageCategoryIds?: Types.InputMaybe<Array<Types.GraphPagePageCategoryInput> | Types.GraphPagePageCategoryInput>;
  noIndex?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  pageScript?: Types.InputMaybe<Types.Scalars['String']['input']>;
  watermark?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UpdatePageMutation = { __typename?: 'Mutation', updatePage: { __typename?: 'GraphPage', id?: number | null } };

export type PageNewMutationVariables = Types.Exact<{
  title: Types.Scalars['String']['input'];
  seoTitle?: Types.InputMaybe<Types.Scalars['String']['input']>;
  seoKeyWords?: Types.InputMaybe<Types.Scalars['String']['input']>;
  seoDescription?: Types.InputMaybe<Types.Scalars['String']['input']>;
  folderId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  domainId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  url: Types.Scalars['String']['input'];
  type?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  noIndex?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type PageNewMutation = { __typename?: 'Mutation', pageNew: { __typename?: 'GraphPage', id?: number | null, domain: { __typename?: 'GraphDomain', id?: number | null }, folder?: { __typename?: 'GraphFolder', id: number } | null } };

export type DuplicatePageMutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  isPublish?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  duplicateFile?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  folderId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  domainId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  title?: Types.InputMaybe<Types.Scalars['String']['input']>;
  url?: Types.InputMaybe<Types.Scalars['String']['input']>;
  seoTitle?: Types.InputMaybe<Types.Scalars['String']['input']>;
  seoDescription?: Types.InputMaybe<Types.Scalars['String']['input']>;
  seoKeyWords?: Types.InputMaybe<Types.Scalars['String']['input']>;
  type?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type DuplicatePageMutation = { __typename?: 'Mutation', duplicatePage: { __typename?: 'GraphPage', id?: number | null } };

export type DuplicatePageForCommonPageMutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  isPublish?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  duplicateFile?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  folderId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  domainId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  title?: Types.InputMaybe<Types.Scalars['String']['input']>;
  url?: Types.InputMaybe<Types.Scalars['String']['input']>;
  seoTitle?: Types.InputMaybe<Types.Scalars['String']['input']>;
  seoDescription?: Types.InputMaybe<Types.Scalars['String']['input']>;
  seoKeyWords?: Types.InputMaybe<Types.Scalars['String']['input']>;
  type?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  noIndex?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type DuplicatePageForCommonPageMutation = { __typename?: 'Mutation', duplicatePageForCommonPage: { __typename?: 'GraphPage', id?: number | null, type?: number | null, publicUrl?: string | null, pageUrl?: string | null, page?: { __typename?: 'GraphPage', id?: number | null } | null } };

export type DuplicateContentPageForCommonPageMutationVariables = Types.Exact<{
  idPageFrom: Types.Scalars['Int']['input'];
  idPageTo: Types.Scalars['Int']['input'];
}>;


export type DuplicateContentPageForCommonPageMutation = { __typename?: 'Mutation', duplicateContentPageForCommonPage: { __typename?: 'GraphPage', id?: number | null, type?: number | null, title?: string | null } };

export type MoveFolderAjaxMutationVariables = Types.Exact<{
  pageId: Types.Scalars['Int']['input'];
  folderId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  domainId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type MoveFolderAjaxMutation = { __typename?: 'Mutation', moveFolderAjax: { __typename?: 'GraphRedirect', redirectPath: string, statusCode: number, params: string } };

export type PublishPageFromAdminPanelMutationVariables = Types.Exact<{
  pageId: Types.Scalars['Int']['input'];
}>;


export type PublishPageFromAdminPanelMutation = { __typename?: 'Mutation', publishPageFromAdminPanel: { __typename?: 'GraphPage', id?: number | null } };

export type PagesQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type PagesQuery = { __typename?: 'Query', pages: { __typename?: 'GraphPathUserPages', search?: string | null, itFolder: boolean, pageView: string, pages: Array<{ __typename?: 'GraphPage', id?: number | null, type?: number | null, title?: string | null, image?: string | null, publicUrl?: string | null, publishedAt?: any | null, user: { __typename?: 'User', email?: string | null } }>, paginator: { __typename?: 'GraphPaginator', totalPages: number, currentPageNumber: number, itemNumberPerPage: number, totalItemCount: number } } };

export type MassMoveFolderAndPageMutationVariables = Types.Exact<{
  pageIds?: Types.InputMaybe<Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input']>;
  folderIds?: Types.InputMaybe<Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input']>;
  toFolderId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  domainId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type MassMoveFolderAndPageMutation = { __typename?: 'Mutation', massMoveFolderAndPage: { __typename?: 'GraphRedirect', redirectPath: string, statusCode: number, params: string } };

export type MassDeleteFolderAndPageMutationVariables = Types.Exact<{
  pageIds?: Types.InputMaybe<Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input']>;
  folderIds?: Types.InputMaybe<Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input']>;
}>;


export type MassDeleteFolderAndPageMutation = { __typename?: 'Mutation', massDeleteFolderAndPage: boolean };

export type PagesByAdminQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type PagesByAdminQuery = { __typename?: 'Query', pagesByAdmin: { __typename?: 'GraphPathAllPages', pages: Array<{ __typename?: 'GraphPage', id?: number | null, createdAt?: any | null, block: boolean, project?: { __typename?: 'GraphDomain', id?: number | null } | null, user: { __typename?: 'User', email?: string | null }, userGraphObject?: { __typename?: 'GraphUser', id?: number | null, userBlock?: { __typename?: 'GraphUserBlock', status?: boolean | null } | null } | null }>, paginator: { __typename?: 'GraphPaginator', totalPages: number, currentPageNumber: number, itemNumberPerPage: number, totalItemCount: number } } };

export type SetBlockPageMutationVariables = Types.Exact<{
  pageId: Types.Scalars['Int']['input'];
  block: Types.Scalars['Boolean']['input'];
}>;


export type SetBlockPageMutation = { __typename?: 'Mutation', setBlockPage: { __typename?: 'GraphPage', id?: number | null } };

export type PagesByIdsByAdminQueryVariables = Types.Exact<{
  ids: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
}>;


export type PagesByIdsByAdminQuery = { __typename?: 'Query', pagesByIdsByAdmin: Array<{ __typename?: 'GraphPage', id?: number | null, type?: number | null, publishContentString?: string | null, prePublishContentString?: string | null, folder?: { __typename?: 'GraphFolder', id: number } | null }> };

export type UpdatePageScreeShotMutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  image?: Types.InputMaybe<Types.Scalars['String']['input']>;
  folderId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type UpdatePageScreeShotMutation = { __typename?: 'Mutation', updatePage: { __typename?: 'GraphPage', image?: string | null } };

export type UpdatePageSettingsMutationVariables = Types.Exact<{
  isExactRequired?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  isExactCheck?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  locationHint?: Types.InputMaybe<Types.Scalars['String']['input']>;
  checkboxPassword?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  password?: Types.InputMaybe<Types.Scalars['String']['input']>;
  passwordHint?: Types.InputMaybe<Types.Scalars['String']['input']>;
  scheduleAccessObj?: Types.InputMaybe<Types.PageScheduleAccessInput>;
  locationObjects?: Types.InputMaybe<Types.PageLocationRestrictionsInput>;
  id: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
}>;


export type UpdatePageSettingsMutation = { __typename?: 'Mutation', updatePageSettings: Array<{ __typename?: 'GraphPage', id?: number | null }> };

export type CountryByFieldQueryVariables = Types.Exact<{
  field: Types.Scalars['String']['input'];
  search: Types.Scalars['String']['input'];
  citiesLimit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  citiesSearch?: Types.InputMaybe<Types.Scalars['String']['input']>;
  afterValue?: Types.InputMaybe<Types.Scalars['String']['input']>;
  afterId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type CountryByFieldQuery = { __typename?: 'Query', countryByField?: { __typename?: 'GraphCountry', id?: number | null, title: string, cities: Array<{ __typename?: 'GraphCity', id?: number | null, title: string }> } | null };
